/**
 * Shared utility to detect if an event target belongs to the editor UI
 * (panels, toolbars, Radix portals, dropdowns, dialogs, etc.)
 * so we never accidentally close the panel or deselect on internal interactions.
 */

const EDITOR_SELECTORS = [
  "[data-design-toolbar]",
  "[data-design-panel]",
  "[data-design-selector]",
  "[data-editor-ui]",
  "[data-overlay-id]",
  // Radix portals / popovers / selects / dialogs
  "[data-radix-popper-content-wrapper]",
  "[data-radix-select-viewport]",
  "[data-radix-select-content]",
  "[data-radix-collection-item]",
  "[data-radix-menu-content]",
  "[data-radix-dropdown-menu-content]",
  "[data-radix-popover-content]",
  // ARIA roles used by Radix portals
  "[role='listbox']",
  "[role='option']",
  "[role='dialog']",
  "[role='menu']",
  "[role='menuitem']",
];

export function isEditorUIElement(target: HTMLElement | null): boolean {
  if (!target) return false;
  for (const sel of EDITOR_SELECTORS) {
    try {
      if (target.matches(sel) || target.closest(sel)) return true;
    } catch {
      // ignore invalid selectors
    }
  }
  return false;
}
